<template>
  <div>
    <toaster />
    <email-preferences />
  </div>
</template>

<script>
import EmailPreferences from "@/features/email-preferences"
import Toaster from "@/features/toaster/components/toaster"

export default {
  name: "EmailPreferencesPage",
  components: {
    EmailPreferences,
    Toaster
  }
}
</script>
